module.exports = __webpack_public_path__ + "static/media/Manectric_gaussian2.95070065.png";